import React from "react";

import Row from "antd/es/row";
import { useIntl } from "react-intl";

import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";
import { LoadingSpinner } from "@mapmycustomers/ui";

import styles from "./FunnelStages.module.scss";
import StageCard from "./StageCard";

interface Props {
  loading: boolean;
  onChange: (stage: Stage | undefined) => void;
  stages: Stage[];
  value: Stage | undefined;
}

const FunnelStages: React.FC<Props> = ({ loading, onChange, stages, value }) => {
  const intl = useIntl();
  return (
    <Row className={styles.container}>
      <StageCard
        onClick={onChange}
        selected={value === undefined}
        stage={undefined}
        title={intl.formatMessage({
          id: "reports.deals.stageBar.allStages",
          defaultMessage: "All Stages",
          description: "All Stages card on the stage bar in Deals reports",
        })}
      />
      {loading ? (
        <LoadingSpinner />
      ) : (
        stages.map((stage) => (
          <StageCard
            key={stage.id}
            onClick={onChange}
            selected={stage.id === value?.id}
            stage={stage}
          />
        ))
      )}
    </Row>
  );
};

export default FunnelStages;
